import * as React from 'react'
import { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

const Container = styled.div<{ isVisible: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  opacity: 0;
  transition: opacity 0.150s ease-in-out;

  ${props => props.isVisible && css`
    opacity: 1;
  `}
`

const FadeInContainer = ({ children }: { children: React.ReactNode }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true)
    }, 50)
  }, [])

  return <Container isVisible={isVisible}>{children}</Container>
}

export default FadeInContainer